// extracted by mini-css-extract-plugin
export default {"colorTextLabel":"z3-z","colorTextValue":"A3-z","swatches":"B3-z","collapseLink":"C3-z","isCollapsed":"D3-z","dropdown":"E3-z","disabled":"F3-z"};